// Trucker.js
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import TruckerConfirm from './pages/trucker/TruckerConfirm'
import TruckerRegistration from './pages/trucker/TruckerRegistration'
import TruckerNavbar from './components/TruckerNavbar'
import TruckerFooter from './components/TruckerFooter'
import Registration from './pages/registration/Registration'

function Trucker() {
  return (
    <div className="app-container">
      <TruckerNavbar />
      <div className="main-content">
        <Routes>
          <Route path="trucker-confirm" element={<TruckerConfirm />} />
          <Route path="trucker-registration" element={<TruckerRegistration />} />
	            <Route path="registration" element={<Registration />} />
        </Routes>
      </div>
      <TruckerFooter />
    </div>
  )
}

export default Trucker